import PropTypes from 'prop-types';
import GenericTable from 'src/components/table/GenericTable';
import { GENERIC_TABLE_DESIGN } from 'src/components/table/GenericTable.design';
import { Edit2, Trash2 } from 'lucide-react';
import { Badge } from "src/@/components/ui/badge";

const HEAD_LABELS = [
  { id: 'nome', label: 'Nome', className: 'flex-1 min-w-[200px] pl-2' },
  { id: 'tipo', label: 'Tipo', className: 'w-[120px]' },
  { id: 'conteudo', label: 'Conteúdo', className: 'flex-1 min-w-[300px]' },
  { id: 'status', label: 'Status', className: 'w-[120px]' },
  { id: 'actions', label: '', className: 'w-[100px]' },
];

export default function TableRespostasRapidas({ data, onEdit, onDelete }) {
  return (
    <GenericTable headLabels={HEAD_LABELS}>
      {data.map((row) => (
        <div key={row._id || Math.random()} className={GENERIC_TABLE_DESIGN.row.container}>
          {/* Nome */}
          <div className="flex-1 min-w-[200px] pl-2 font-medium text-gray-900">
            {row.titulo}
          </div>

          {/* Tipo */}
          <div className="w-[120px] text-sm text-gray-600 capitalize">
            {row.tipo}
          </div>

          {/* Conteúdo */}
          <div className="flex-1 min-w-[300px] text-sm text-gray-500 truncate pr-4">
            {row.tipo === 'texto' ? (
              <span>
                {row?.resposta?.length > 60
                  ? `${row?.resposta?.substring(0, 60)}...`
                  : row?.resposta}
              </span>
            ) : (
              <span className="italic text-gray-400">
                {row.tipo === 'audio' ? 'Áudio gravado' : 'Arquivo anexado'}
              </span>
            )}
          </div>

          {/* Status */}
          <div className="w-[120px]">
            <Badge
              className={`${row.ativo !== "1"
                ? "bg-red-50 text-red-600 hover:bg-red-100 border-red-200"
                : "bg-green-50 text-green-600 hover:bg-green-100 border-green-200"
                } border rounded-md shadow-none font-normal`}
            >
              {row.ativo !== "1" ? "Inativo" : "Ativo"}
            </Badge>
          </div>

          {/* Actions */}
          <div className="w-[100px] flex justify-end gap-2">
            <button
              onClick={() => onEdit(row)}
              className="p-2 rounded-lg text-gray-400 hover:bg-violet-50 hover:text-violet-600 transition-all"
              title="Editar"
            >
              <Edit2 size={18} />
            </button>
            <button
              onClick={() => onDelete(row)}
              className={GENERIC_TABLE_DESIGN.common.deleteButton}
              title="Excluir"
            >
              <Trash2 size={18} />
            </button>
          </div>
        </div>
      ))}
    </GenericTable>
  );
}

TableRespostasRapidas.propTypes = {
  data: PropTypes.array,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};
